import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import React, { memo } from "react";
import { GridBox, Link, FacebookLogoIcon, InstagramLogoIcon, OkLogoIcon, TwitterLogoIcon, VkLogoIcon, TelegramLogoIcon, AlisaLogoIcon } from "@pochta/ui";
import { FooterIconWrapper } from "../Footer.styles";

var FooterSocials = function FooterSocials(_ref) {
  var list = _ref.list;
  var IconComponents = {
    FacebookLogoIcon: FacebookLogoIcon,
    InstagramLogoIcon: InstagramLogoIcon,
    OkLogoIcon: OkLogoIcon,
    TwitterLogoIcon: TwitterLogoIcon,
    VkLogoIcon: VkLogoIcon,
    TelegramLogoIcon: TelegramLogoIcon,
    AlisaLogoIcon: AlisaLogoIcon
  }; // TODO: добавить лимиты на количество элементов для разных экранов

  return /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: "25",
    flexbox: true,
    justifyContent: {
      md: "flex-start",
      lg: "center",
      xl: "center"
    }
  }, list === null || list === void 0 ? void 0 : list.map(function (item) {
    var Icon = IconComponents[item.iconName];
    return Icon && /*#__PURE__*/React.createElement(FooterIconWrapper, {
      key: item.link
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.link,
      title: item.title,
      underline: "none",
      color: "inherit",
      target: item.openInNewTab ? "_blank" : "_self",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "s"
    })));
  }));
};

export default /*#__PURE__*/memo(FooterSocials);